import { render, staticRenderFns } from "./FotavOutputTable.vue?vue&type=template&id=22250369&scoped=true&"
import script from "./FotavOutputTable.vue?vue&type=script&lang=js&"
export * from "./FotavOutputTable.vue?vue&type=script&lang=js&"
import style0 from "./FotavOutputTable.vue?vue&type=style&index=0&id=22250369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22250369",
  null
  
)

export default component.exports